module.exports = __webpack_public_path__ + "static/media/WtbProdsProds.39a10a7f.jpg";